import React from 'react';
import ContactSection from '../components/ContactSection';
import SEOHead from '../components/SEOHead';

const ContactPage = () => {
  return (
    <div className="pt-20">
      <SEOHead 
        title="Contact Gegadyne Energy | Industrial Battery Enquiry India"
        description="Contact Gegadyne Energy for industrial battery requirements in India. Get quotes for traction batteries, energy storage systems, ground power units. Engineering consultation available."
        keywords="contact Gegadyne Energy, industrial battery enquiry India, battery manufacturer contact, traction battery quote, ESS quote India"
        canonicalPath="/contact"
      />
      <section className="py-12 sm:py-16 bg-gradient-to-b from-gray-900 to-gray-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-4 sm:mb-6">
            Contact <span className="text-emerald-400">Us</span>
          </h1>
          <p className="text-base sm:text-lg lg:text-xl text-gray-400 max-w-3xl mx-auto">
            Get in touch with our engineering team for industrial battery requirements in India.
          </p>
        </div>
      </section>
      <ContactSection />
    </div>
  );
};

export default ContactPage;
